import React from "react";
import { ArrowBackCircle, ArrowDownCircle, ArrowForwardCircle } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesMed from "./stylesMed"
import Authenticate from "../Functions/MedRepAuthenticate"

function convertNumToTime(number) {
    var sign = (number >= 0) ? 1 : -1;
    number = number * sign;
    var hour = Math.floor(number);
    var decpart = number - hour;
    var min = 1 / 60;
    decpart = min * Math.round(decpart / min);
    var minute = Math.floor(decpart * 60) + '';
    if (minute.length < 2) {
        minute = '0' + minute;
    }
    sign = sign == 1 ? '' : '-';
    var time = sign + hour + ':' + minute;
    return time;
}

export default class HCPDetail extends React.Component {

    constructor() {
        super();
        this.state = {
            HCP: "",
            details: [{ name: "Name" }, { name: "Type" }, { name: "Specialty" }, { name: "Personality Style" }, { name: "CPC" }, { name: "CF" },
            { name: "Brick Info" }, { name: "Area" }, { name: "Sub Area" }, { name: "Address" }, { name: "Phone" }, { name: "Mobile" },
            { name: "Email" }, { name: "Birthday" }, { name: "Items of Interest" }, { name: "# of Visits" }, { name: "Scientific Support" },
            { name: "Working Days" }, { name: "Working Hours" }, { name: "LVD" }],
            //, { name: "Prefered Visit Time" }
            showVisits: false,
            items: [],
            itemsCopy: [],
            loading: true,
            token: "",
            isHistory: false,
            historyName: "",
            previousVisits: [],
            showDetail: [],
            user: "",
            authenticate: false,
            alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const client = localStorage.getItem('HCP');
        const token = localStorage.getItem('Token');
        const isHistory = localStorage.getItem('HistoryID');
        const historyName = localStorage.getItem('HistoryName');
        const user = localStorage.getItem("User");
        await this.setState({
            HCP: JSON.parse(client), token: JSON.parse(token), isHistory: JSON.parse(isHistory), historyName: JSON.parse(historyName),
            user: JSON.parse(user)
        });

        if (this.state.isHistory) {
            const readURL = constantURI() + "odooController/MedRepRead";
            const previousVisitsBody = {
                jsonrpc: "2.0",
                params: {
                    method: "search_read",
                    model: "calendar.event",
                    args: [],
                    kwargs: {
                        fields: ["name", "x_status", "start_datetime", "start_date", "partner_ids"],
                        domain: [["partner_ids", "=", this.state.historyName]],
                        order: "start_date DESC"
                    }
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(readURL, previousVisitsBody).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                        this.setState({ temp2: data.result })
                        const groups = this.groupArrayOfObjects(this.state.temp2, 'start_date');
                            await this.setState({ previousVisits: groups, loading: false });
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                alert("Please connect to the Internet!")
                this.setState({ loading: false });
            }
        }
        else {
            const clientDetailBody = {
                jsonrpc: "2.0",
                params: {
                    method: "search_read",
                    model: "res.partner",
                    args: [],
                    kwargs: {
                        fields: ["name", "clienttype", "x_specialty_id", "x_availability", "potential", "cf", "brick", "state_id", "x_city_id", "street", "phone", "mobile", "email", "birthday", "x_clientitems_ids", "x_month_visits", "x_deal", "x_workdays", "x_workhours", "prefered_visit_time"],
                        domain: [["name", "=", this.state.HCP]]
                    }
                },
                "token": this.state.token
            }
            const clientDetailBodyFull = {
                jsonrpc: "2.0",
                params: {
                    method: "search_read",
                    model: "res.partner",
                    args: [],
                    kwargs: {
                        fields: ["name", "clienttype", "x_specialty_id", "x_availability", "potential", "cf", "brick", "state_id", "x_city_id", "street", "phone", "mobile", "email", "birthday", "x_clientitems_ids", "x_month_visits", "x_deal", "x_workdays", "x_workhours", "prefered_visit_time"],
                        domain: [["x_repuser", "=", this.state.user]]
                    }
                },
                "token": this.state.token
            }
            const clientDetailURL = constantURI() + "odooController/MedRepRead";

            if (this.state.authenticate) {
                await _post(clientDetailURL, clientDetailBody).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await this.setState({ items: data.result, itemsCopy: data.result, loading: false });
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
                await _post(clientDetailURL, clientDetailBodyFull).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await localStorage.setItem('HCPDetail', JSON.stringify(data.result));
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                const HCPsDetail = JSON.parse(localStorage.getItem("HCPDetail"));
                HCPsDetail.map((item, index) => {
                    if (item.name === this.state.HCP) {
                        var temp = [];
                        temp.push(item);
                        this.setState({ items: temp, itemsCopy: temp, loading: false })
                    }
                })
            }
        }
    }

    onShowVisits = () => {
        this.setState(s => ({ showVisits: !s.showVisits }));
    }

    groupArrayOfObjects(list, key) {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    onShowDetails = (index) => {
        this.setState({ ...this.state.showDetail[index] = !this.state.showDetail[index] });
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={async () => { await localStorage.setItem("HistoryID", JSON.stringify(false)); this.props.history.goBack(); }} color={'#00bfff'} height="50px" width="50px" />
                        </div>
                        <h5 className="col text-center" style={stylesMed.clientNameDetail}>{(this.state.isHistory) ? this.state.historyName : this.state.HCP}</h5>
                        <div className="col"></div>
                    </div>
                    <div className="mt-4"></div>
                    {(!this.state.isHistory) ?
                        this.state.details.map((item, index) => {
                            return (
                                <div key={index}>
                                    <div className="row justify-content-center align-content-center m-1" style={stylesMed.clientDetailCard}>
                                        <h4 className="col-sm-4 mt-1">{item.name}:</h4>
                                        <p className="col-sm-8 mt-1" style={{ fontSize: 20 }}>
                                            {this.state.items.map((item2) => {
                                                if (index === 0)
                                                    return item2.name
                                                else if (index === 1)
                                                    return item2.clienttype[1]
                                                else if (index === 2)
                                                    return item2.x_specialty_id
                                                else if (index === 3)
                                                    return item2.x_availability
                                                else if (index === 4)
                                                    return item2.potential[1]
                                                else if (index === 5)
                                                    return item2.cf
                                                else if (index === 6)
                                                    return item2.brick
                                                else if (index === 7)
                                                    return item2.state_id[1]
                                                else if (index === 8)
                                                    return item2.x_city_id[1]
                                                else if (index === 9)
                                                    return item2.street
                                                else if (index === 10)
                                                    return item2.phone
                                                else if (index === 11)
                                                    return item2.mobile
                                                else if (index === 12)
                                                    return item2.email
                                                else if (index === 13)
                                                    return item2.birthday
                                                else if (index === 14)
                                                    return item2.x_clientitems_ids
                                                else if (index === 15)
                                                    return item2.x_month_visits
                                                else if (index === 16)
                                                    return item2.x_deal
                                                else if (index === 17)
                                                    return item2.x_workdays
                                                else if (index === 18)
                                                    return item2.x_workhours
                                                else if (index === 19)
                                                    return ""
                                                //else if (index === 20 && item2.prefered_visit_time != 0)
                                                //    return convertNumToTime(item2.prefered_visit_time)
                                                else return null
                                            })
                                            }
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                        :
                        <div>
                            {
                                Object.entries(this.state.previousVisits).map((key, value) => {
                                    return (
                                        <div className="pt-3" style={stylesMed.mainBackgroundColor} key={value}>
                                            <div className="btn row bg-light" style={stylesMed.planTabs} onClick={() => this.onShowDetails(value)}>
                                                <div className="row">
                                                    {(this.state.showDetail[value]) ?
                                                        <ArrowDownCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                                        :
                                                        <ArrowForwardCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                                    }
                                                    <p className="col pt-2 d-flex justify-content-start" style={stylesMed.planVisitDate}>{new Date(key[0]).toDateString()}</p>
                                                </div>
                                            </div>
                                            {(this.state.showDetail[value]) ?
                                                key[1].map((item, index) => {
                                                    return (
                                                        <div className="row m-2" style={stylesMed.planItemDetail} key={index}>
                                                            <div className="col-sm-5">
                                                                <p style={stylesMed.planItemDetailName}>Visit #{index + 1}</p>
                                                                <p>{item.name}</p>
                                                            </div>
                                                            <div className="col-sm-4 mt-5">
                                                                <p style={(item.x_status === "2") ? stylesMed.planVisitPending : ((item.x_status === "1") ? stylesMed.planVisitCompleted : stylesMed.planVisitCancelled)}>
                                                                    {(item.x_status === "2") ? "Cancelled" : ((item.x_status === "1") ? "Completed" : "Pending")}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : null
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                </div>
            )
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    <div className="pt-3">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageRep")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}
